import { HttpClient } from '@angular/common/http';
import { ColoreEvento } from 'app/model/colore_evento';
import { RESTArray } from '../angular-rest';

export class CategoriaEvento extends RESTArray<ColoreEvento> {
	public categoria: string;

	constructor($http: HttpClient, uri: string, initialValue: CategoriaEvento) {
		super(
			$http,
			uri,
			(h, u, r) => new ColoreEvento(h, u, r),
			t => ({ id: t.nome }));
		Object.assign(this, initialValue);
	}
}



// WEBPACK FOOTER //
// ./src/app/model/categoria_evento.ts